import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';
import cl from "./Copy.module.css";
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal';
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { selectStyle } from './selectStyle';
import { Link } from 'react-router-dom'; 
import AddClientForm from '../ClientForm/ClientForm';
import Sale from '../Sale/Sale';

const BookingCopyModal = ({ BookingService, BookingDetailsService, defaultBooking }) => {
    const initBookingModel = (Booking) => {
        return {
            id: Booking.id,
            booking_id: Booking.booking_id,
            seller_id: Booking.seller_id,
            status_id: Booking.status_id,
            user_id: Booking.user_id,
            sender_country_id: Booking.sender_country_id,
            sender_city_id: Booking.sender_city_id,
            reciever_country_id: Booking.reciever_country_id,
            reciever_city_id: Booking.reciever_city_id,
            type_id: Booking.type_id,
            created_at: Booking.created_at || '',
            updated_at: new Date().toLocaleString(),
            message: Booking.message || '',
            description: Booking.description || '',
            marine_subtype_id: Booking.marine_subtype_id,
            icoterm_id: Booking.icoterm_id,
            land_subtype_id: Booking.land_subtype_id,
            railway_subtype_id: Booking.railway_subtype_id,
            marine_line_id: Booking.marine_line_id,
            driver_id: Booking.driver_id,
            driver_name: Booking.driver_name,
            driver_surname: Booking.driver_surname,
            driver_phone: Booking.driver_phone,
            driver_car: Booking.driver_car,
            period_start_at: Booking.period_start_at || '',
            period_end_at: Booking.period_end_at || '',
            custom_id: Booking.custom_id || 0,
            issued_price: Booking.issued_price || 0,
            client: Booking.client || {
                firstname: '',
                lastname: '',
                email: '',
                mobile: ''
            }
        }
    }

    const initSaleModel = () => ({
        container_id: 0,
        bl_id: 0,
        service_id: 0,
        marine_line_id: 0,
        bill_of_landing: "",
        amount: 0,
        agent_price: 0,
        agent_invoice: "",
        client_price: 0,
        client_invoice: ""
    });

    
    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
    ];
    
    const marineSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FTL' },
        { value: 2, label: 'LTL' },
        { value: 3, label: 'FCL' },
        { value: 4, label: 'Oversized' },
    ];
    
    const railwaySubtype = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FCL' },
        { value: 2, label: 'LCL' },
        { value: 3, label: 'Wagon' },
        { value: 4, label: 'Cistern' },
        { value: 5, label: 'Oversized' },
    ];
    
    const incotermTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'FOB' },
        { value: 2, label: 'FCA' },
        { value: 3, label: 'ExW' },
        { value: 4, label: 'DAP' },
        { value: 5, label: 'CIF' },
    ];
    
    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'მიმდინარე' },
        { value: 2, label: 'გზაში' },
        { value: 3, label: 'დასრულებული' },
        { value: 4, label: 'გაუქმებული' },
    ];
    const customsTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'იმპორტი' },
        { value: 2, label: 'ექსპორტი' },
        { value: 3, label: 'ტრანზიტი' },
        { value: 4, label: 'რეექსპორტი' },
    ];
    const { appState } = useContext(AppContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newBooking, setNewBooking] = useState(initBookingModel(defaultBooking));
    const [salesData, setSalesData] = useState([]);
    const [validates, setValidates] = useState({});
    const [textValue, setTextValue] = useState('');
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

    useEffect(() => {
        if (defaultBooking) {
            const initialData = initBookingModel(defaultBooking);
            setNewBooking(initialData);
            setTextValue(initialData.message || '');
            
            // Load and copy sales data
            loadAndCopySales(defaultBooking.id);
        }
    }, [defaultBooking]);

    // const loadAndCopySales = async (bookingId) => {
    //     try {
    //         const details = await BookingDetailsService.getByBookingId(bookingId);
    //         setSalesData(details.map((detail, index) => ({
    //             id: index + 1,
    //             data: {...detail, id: 0} // Reset IDs for new copies
    //         })));
    //     } catch (error) {
    //         console.error("Error loading sales data:", error);
    //     }
    // };

    const loadAndCopySales = async (bookingId) => {
        try {
            const details = await BookingDetailsService.getByBookingId(bookingId);
            if(details != null) {
                setSalesData(details.booking_details);
            }
        } catch (error) {
            console.error("Error loading sales data:", error);
        }
    };

    const handleCustomsChange = (selectedOption) => {
        setNewBooking(prevPrice => ({
            ...prevPrice,
            custom_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const updateSaleData = (id, newData) => {
        setSalesData(prevSales => 
            prevSales.map(sale => 
                sale.id === id 
                    ? { ...sale, data: { ...sale.data, ...newData } } 
                    : sale
            )
        );
    };

    const addSale = () => {
        const newId = salesData.length > 0 ? Math.max(...salesData.map(s => s.id)) + 1 : 1;
        setSalesData([...salesData, { id: newId, data: initSaleModel() }]);
    };

    const removeSale = (id) => {
        setSalesData(salesData.filter((sale) => sale.id !== id));
    };

    // Handler functions (same as Add component)
    const handleTypeIdChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleLandSubtypeChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleStatusTypeChange = (selectedOption) => {
        setNewBooking(prev => ({
            ...prev,
            status_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setTextValue(newValue);
        setNewBooking(prev => ({
            ...prev,
            message: newValue
        }));
    };

    const saveHandle = async () => {
        const isValidate = validateBooking(newBooking);
    
        if (isValidate) {
            try {
                const bookingData = {
                    ...newBooking,
                    booking_id: "0", 
                    seller_id: appState.user.id,
                    created_at: new Date().toLocaleString(),
                    id: 0
                };
    
                const bookingResponse = await BookingService.add(bookingData);
                
                console.log(bookingResponse)
                if (!bookingResponse?.id) {
                    throw new Error('Failed to get booking ID from response');
                }
                
                console.log(salesData)
                if (salesData && Array.isArray(salesData)) {
                    const createPromises = salesData.map(sale => {
                        const saleData = {
                            ...sale,
                            booking_id: bookingResponse.id,
                            id: 0
                        };
                        console.log("sales data to be added", saleData)
                        return BookingDetailsService.add(saleData);
                    });
                    await Promise.all(createPromises);
                }
                
                setIsModalOpen(false);
            } catch (error) {
                console.error("Error copying booking:", error);
                // Show error to user
                alert(`Copy failed: ${error.response?.data?.message || error.message}`);
            }
        }
    };

    const validateBooking = (booking) => {
        const messages = {};

        if (booking.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (booking.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };

    return (
        <div>
            <span className={cl.editBtn} onClick={saveHandle}>
                <Pen /> კოპირება
            </span>

            {/* <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead}>
                    <h3><span className={cl.iconHead}><Pen /></span> კოპირება</h3>
                </div>

                <AddClientForm 
                    newBooking={newBooking} 
                    setNewBooking={setNewBooking} 
                    validates={validates}
                />
                
                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა/პორტი</legend>
                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.sender_country_id}
                        childId={newBooking.sender_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates?.sender_country_id ? true : false}
                        validateSub={validates?.sender_city_id ? true : false}
                    />
                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.reciever_country_id}
                        childId={newBooking.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewBooking(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საბაჟოს ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={customsTypeOptions}
                            value={customsTypeOptions.find(option => option.value === newBooking.customsOption)}
                            onChange={handleCustomsChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newBooking.status_id)}
                            onChange={handleStatusTypeChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newBooking.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newBooking.type_id === 0 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newBooking.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newBooking.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newBooking.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საზღვაო ხაზი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={marines}
                            value={marines.find(option => option.value === newBooking.marine_line_id)}
                            onChange={(selectedOption) => {
                                setNewBooking(prevState => ({
                                    ...prevState,
                                    marine_line_id: selectedOption ? selectedOption.value : 0,
                                }));

                                if (selectedOption) {

                                    setNewBooking(prevState => ({
                                        ...prevState,
                                    }));
                                } else {
                                    setTypeOptions(initialTypeOptions);
                                }

                            }}
                            placeholder="საზღვაო ხაზი"
                            isClearable={true}
                        />
                    </div>

                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="message"
                        value={textValue}
                        onChange={handleTextChange}
                        rows={4}
                        cols={100}
                        style={{selectStyle, border: '1px solid grey', borderRadius: '6px', padding: '8px'}}
                        placeholder="კომენტარი"
                    />
                </fieldset>

                <h2 style={{textAlign: 'center'}}>SALE</h2>
                <button onClick={addSale} className={cl.btnPrimary} style={{marginLeft: '0', marginBottom: '20px'}}>
                    სეილის დამატება
                </button>
                <div className="sales-list">
                    {salesData.map((sale) => (
                        <div key={sale.id}>
                            <Sale 
                                key={sale.id}
                                id={sale.id}
                                saleData={sale.data}
                                onUpdate={updateSaleData}
                            />
                            <button 
                                className={cl.btnPrimary} 
                                style={{backgroundColor:'rgb(255, 68, 68)', marginLeft: '0', marginBottom: '20px'}} 
                                onClick={() => removeSale(sale.id)}
                            >
                                Remove
                            </button>
                        </div>
                    ))}
                </div>

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>
            </Modal> */}
        </div>
    );
};

export default BookingCopyModal;